<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Role Permission</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Master / Data Role Permission</span>
      </div>
    </div>
    <div class="grid role-layout">
      <div
        class="role-list-wrapper"
        :class="showForm ? 'col-12 md:col-4' : 'col-12'"
      >
        <div class="card bg-white h-full">
          <div class="flex justify-content-end mb-2">
            <Button
              v-if="!showForm"
              icon="pi pi-plus"
              label="Role"
              class="mr-2"
              @click="onAddData"
            />
          </div>
          <fx-table
            :items="items"
            :loading="isLoading"
            :total="totalRecords"
            :grid-options="options"
            :filters="filters"
            :custom-row-class="getRowClass"
            @request="onRequestData"
            @sort="onSort($event)"
          >
            <template #columns>
              <Column field="name" header="Nama Role" style="min-width: 15rem">
              </Column>
              <Column
                field="descriptions"
                header="Deskripsi"
                style="min-width: 15rem"
              >
              </Column>
              <Column style="flex-grow: 1; justify-content: flex-end">
                <template #body="{ data }">
                  <Button
                    type="button"
                    icon="pi pi-pencil"
                    class="
                      p-button-outlined p-button-secondary p-button-text
                      mr-2
                    "
                    @click="onEditData(data)"
                  />
                </template>
              </Column>
            </template>
          </fx-table>
        </div>
      </div>
      <Transition name="slide-form">
        <div v-if="showForm" class="role-form-wrapper col-12 md:col-8">
          <div class="card bg-white h-full">
            <div class="flex justify-content-between align-items-center mb-3">
              <div>
                <h3 class="m-0">
                  {{ editMode ? 'Edit Role' : 'Tambah Role' }}
                </h3>
                <small class="text-color-secondary">
                  Atur hak akses role
                </small>
              </div>

              <Button
                icon="pi pi-times"
                class="p-button-rounded p-button-text"
                @click="showForm = false, selectedRoleId = null"
              />
            </div>
            <form-Role
              :item="form"
              :loading="isLoadingSave"
              :list-permission="list_permission"
              :editMode="editMode"
              @save="onSaveData"
              @close="showForm = false, selectedRoleId = null"
            />
          </div>
        </div>
      </Transition>
    </div>
    <Dialog
      :header="form && form.id > 0 ? 'Edit Permission' : 'Tambah Permission'"
      v-model:visible="dialog"
      class="p-overflow-hidden"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '95vw' }"
      modal
      maximizable
    >
      <form-Role
        :item="form"
        :loading="isLoadingSave"
        :list-permission="list_permission"
        :editMode="editMode"
        @save="onSaveData"
        @close="dialog = false"
      />
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import FxTable from '@/components/FxTable'
import Hotkey from '@/components/Hotkey'
import FormRole from '@/components/master/FormRole'
import errorHandler from '@/helpers/error-handler'
import PermissionService from '@/services/PermissionService'
import RoleService from '@/services/RoleService'
import UserService from '@/services/UserService'
import defineAbilitiesFor from '@/services/rules'
import { FilterMatchMode } from 'primevue/api'
import { inject } from 'vue'

export default {
  name: 'Role',
  components: {
    FormRole,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      UserService: null,
      RoleService: null,
      PermissionService: null,
      dialog: false,
      dialogHapus: false,
      isLoading: false,
      isLoadingSave: false,
      editMode: false,
      showForm: false,
      selectedRoleId: null,
      ability: inject('ability'),
      user: {},
      items: [],
      permissions: [],
      list_permission: [],
      form: {
        id: null,
        name: null,
        descriptions: null,
        permission: [],
      },
      Role: [],
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: 'name',
        sortOrder: '1',
        filters: null,
      },
      filters: {
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        descriptions: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      containModesOption: [
        { label: 'Contains', value: FilterMatchMode.CONTAINS },
      ],
      equalModesOption: [{ label: 'Equals', value: FilterMatchMode.EQUALS }],
    }
  },
  created() {
    this.UserService = new UserService()
    this.RoleService = new RoleService()
    this.permissionService = new PermissionService()
  },
  async mounted() {
    this.loadData()
    this.permissionService
      .get()
      .then((res) => {
        this.list_permission = res.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Role Permission', this)
      })
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.RoleService.paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data
          this.totalRecords = res.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Rol1e Permission', this)
        })
        .finally(() => (this.isLoading = false))
    },
    updatePermission() {
      const user = localStorage.getItem('user')
      const userObject = JSON.parse(user)
      const userId = userObject.id

      this.UserService.getById(`/${userId}`)
        .then((res) => {
          if (res.data.status === 1) {
            this.user = res.data.data
            this.permissions = []

            this.user.roles.forEach((role) => {
              this.permissions.push(
                ...role.permissions.map((permission) => permission.name)
              )
            })
            this.ability.update(defineAbilitiesFor(this.permissions))
          }
        })
        .catch((err) => {
          errorHandler(err, 'Data Role Permission', this)
        })
    },
    onSort(e) {
      this.options.value = e
      this.loadData()
    },
    onAddData() {
      this.selectedRoleId = null
      this.editMode = false

      this.form = {
        id: null,
        name: '',
        descriptions: '',
        permissions: [],
      }

      this.showForm = true
    },
    onEditData(data) {
      this.editMode = true
      this.selectedRoleId = data.id
      this.form = { ...data }
      this.showForm = true
    },
    async onSaveData(data) {
      this.isLoadingSave = true

      try {
        let roleId = data.id

        if (this.editMode) {
          // Update role
          await this.RoleService.update(roleId, {
            name: data.name,
            descriptions: data.descriptions,
          })
        } else {
          // Create role
          const res = await this.RoleService.add({
            name: data.name,
            descriptions: data.descriptions,
          })

          roleId = res.data.data.id
        }

        // Assign permission
        await this.permissionService.assign({
          role_id: roleId,
          permissions: data.permissions,
        })

        this.loadData()
        this.updatePermission()

        this.showForm = false
        this.selectedRoleId = null

        this.$toast.add({
          severity: 'success',
          summary: 'Role',
          detail: this.editMode
            ? 'Role berhasil diperbarui.'
            : 'Role berhasil ditambahkan.',
          life: 3000,
        })
      } catch (err) {
        errorHandler(err, 'Data Role', this)
        console.log(err)
      } finally {
        this.isLoadingSave = false
      }
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.onAddData()
      }
    },
    getRowClass(data) {
      return data.id === this.selectedRoleId ? 'selected-role-row' : ''
    },
  },
}
</script>

<style scoped>
:deep(tr.selected-role-row > td) {
  background-color: #dbeafe !important;
  transition: background-color 0.2s;
}
.role-layout {
  align-items: stretch;
}

.role-list-wrapper {
  transition: all 0.35s ease;
}

.role-form-wrapper {
  transition: all 0.35s ease;
}

.slide-form-enter-active,
.slide-form-leave-active {
  transition: all 0.3s ease;
}

.slide-form-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.slide-form-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-form-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.slide-form-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.card {
  transition: all 0.35s ease;
}
</style>
